import React from "react";

interface Props {
  task: server.dto.UserTask
}

const TaskPreview = ({ task }: Props) => {
  const domParser = new DOMParser();

  // For a preview, we don't actually want render the HTML. We just want the raw text.
  // For example if the text is very large, it will overflow
  const dom = domParser.parseFromString(task.body ?? "", "text/html");
  const text = dom.documentElement.innerText;
  const [firstLine] = text.split("\n");

  const previewLine = firstLine ? (firstLine.slice(0, 100) + "…") : "";
  return <>
    <div>{task.title}</div>
    <div className="s1_small truncate">{previewLine}</div>
  </>;
};

export default TaskPreview;